<template>
  <div v-if="event" class="event-tile__content">
    <div class="event-tile__description">
      <div
        class="event-tile__picture"
        :style="[
          event.mainImage
            ? { 'background-image': 'url(' + imageSrc + ')' }
            : { 'background-image': 'url(/img/benefit-no-image.jpg)' }
        ]"
      />

      <div class="ml-6">
        <div class="event-tile__title">
          <div class="v-card-h2">{{ event.name }}</div>
        </div>

        <div class="event-tile__details hide-md">
          <div class="v-card-h3" style="word-break: break-word;">
            {{ event.description || event.descriptionShort || 'Brak opisu' }}
          </div>
        </div>
      </div>
    </div>

    <div class="event-tile__media">
      <ul class="tags-container flex-column px-0">
        <li class="tag">
          <v-icon class="mr-4 lighten-2">storefront</v-icon>

          <router-link v-if="event.partner" :to="{ path: `/partners/${event.partner.id}` }">
            {{ event.partner.name }}
          </router-link>

          <p v-else class="lighten-2">Usługa dostępna u wielu partnerów</p>
        </li>

        <li class="tag">
          <v-icon class="mr-4 lighten-2">mdi-map-marker-outline</v-icon>

          <p>{{ place }}</p>
        </li>

        <li v-if="event.start && event.end" class="tag">
          <v-icon class="mr-4 lighten-2">mdi-calendar</v-icon>

          <p>{{ event.start | dateFilter }} - {{ event.end | dateFilter }}</p>
        </li>

        <li class="tag">
          <v-icon class="mr-4 lighten-2">{{ event.type | benefitIconType }}</v-icon>

          <p class="sr-only">Typ zniżki</p>

          <p>
            <b>
              {{ event.type | benefitType }}:
              <span>{{ event | benefitValue }}</span>
            </b>
          </p>
        </li>

        <li role="region" aria-label="Grupy" class="tag">
          <v-icon class="mr-4 lighten-2">mdi-account-group</v-icon>

          <p class="sr-only">Grupy</p>

          <p>
            <b>
              Grupy:
            </b>

            <span>{{ groups }}</span>
          </p>
        </li>
      </ul>

      <v-btn large outlined elevation="0" color="primary" @click="goToEvent">Zobacz usługę</v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  address,
  benefitIconType,
  benefitType,
  benefitValue,
  dateFilter,
  DisplayBenefitType,
  PublicSettings
} from '@witkac/kartamiejska-shared';

import { mediaMixin } from '@/mixins/media';

// @vuese
// Widok wydarzenia strona główna
// @group components
export default {
  name: 'HomeEvent',
  filters: { address, benefitIconType, benefitType, benefitValue, dateFilter, DisplayBenefitType },
  mixins: [mediaMixin],
  computed: {
    ...mapState({
      event: state => {
        let index = 0;
        if (state.benefit.list.length > 1) {
          index = Math.floor(Math.random() * state.benefit.list.length);
        }
        return state.benefit.list[index];
      },
      noGroupSetting: state => state.settings[PublicSettings.NO_GROUP_SELECTED_NAME].value
    }),
    imageSrc() {
      return this.mediaUrl + this.event.mainImage;
    },
    place() {
      if (this.event.place) {
        return address(this.event.place);
      }
      return 'Usługa dostępna we wszystkich obiektach';
    },
    groups() {
      if (!this.event.groups.length) {
        return this.noGroupSetting;
      }
      const firstThree = this.event.groups.map(group => group.name).slice(0, 3);
      const left = this.event.groups.length - 3;
      return `${firstThree.join(', ')} ${left > 0 ? 'oraz ' + left + ' więcej' : ''}`;
    }
  },
  methods: {
    // @vuese
    // Pokaż wydarzenie
    goToEvent() {
      this.$router.push({
        name: 'eventDetails',
        params: { id: this.event.id }
      });
    }
  }
};
</script>
